import Multiselect from 'vue-multiselect';

import search from '@/components/search/index.vue';

import Api from '@/utils/api';

import {
  ROLE_QA_EXPERT,
  ROLE_PROOF_READER,
  ROLE_PROJECT_MNG,
} from '@/utils/const';

export default {
  components: {
    Multiselect,
    search,
  },
  props: {
    switchList: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      scopeArray: [{
        ID: 1,
        Name: 'Projects',
      },
      {
        ID: 2,
        Name: 'Tasks',
      },
      {
        ID: 3,
        Name: 'Jobs',
      },
      {
        ID: 4,
        Name: 'Reports',
      },
      ],

      filter: {
        sourceLanguages: [],
        targetLanguages: [],
        projectManagers: [],
        statuses: [],
        deadline: [],

        roleList: [{
          ID: ROLE_PROJECT_MNG,
          Name: 'Project manager',
        }, {
          ID: ROLE_PROOF_READER,
          Name: 'Proofreader',
        }, {
          ID: ROLE_QA_EXPERT,
          Name: 'QA Expert',
        }],

      },

      params: {
        Scope: '',
        Managers: '',
        Statuses: '',
        SourceLanguages: '',
        TargetLanguages: '',
        Query: '',
      },
    };
  },
  created() {
    this.getFilters();
  },
  methods: {

    getFilters() {
      Api.overviews.getOverviewFilters()
        .then((response) => {
          if (response.data.Status) {
            this.filter.sourceLanguages = response.data.Data.SourceLanguages.map((item) => {
              item.CountryISOCode = item.CountryISOCode == null ? 'unknown' : item.CountryISOCode;
              return item;
            });
            this.filter.targetLanguages = response.data.Data.TargetLanguages.map((item) => {
              item.CountryISOCode = item.CountryISOCode == null ? 'unknown' : item.CountryISOCode;
              return item;
            });
            this.filter.projectManagers = response.data.Data.ProjectManagers;
            this.filter.statuses = response.data.Data.Statuses;

            // this.filter.deadline = response.data.Data.DeadlineRangeSlug;
          }
        });
    },

    limitText(count) {
      return `and ${count} others`;
    },

    holderSearch(searchString) {
      this.params.Query = searchString;
    },

    sendFilters() {
      this.$emit('sendFilters', this.transformParams());
    },

    transformParams() {
      const params = {};

      for (const [name, value] of Object.entries(this.params)) {
        if (value !== null) {
          if (name === 'Query') {
            params[name] = this.$refs.child.search;
            continue;
          }
          if (typeof value === 'object' && value.length === 0) {
            params[name] = '';
          } else {
            if (typeof value === 'object') {
              if (value.length !== undefined) {
                switch (name) {
                case 'Scope':
                  params[name] = value.Name;
                  break;
                case 'Statuses':
                  params[name] = value.map((item) => item.Name).join('|');
                  break;
                case 'SourceLanguages':
                  params[name] = value.map((item) => item.ID).join('|');
                  break;
                case 'TargetLanguages':
                  params[name] = value.map((item) => item.ID).join('|');
                  break;
                case 'DeadlineRangeSlug':
                  params[name] = value.map((item) => item.slug).join('|');
                  break;
                case 'Managers':
                  params[name] = value.map((item) => item.UserId).join('|');
                  break;
                case 'Query':
                  params[name] = value;
                  break;
                }
              } else {
                params[name] = value.Name;
              }
            } else {
              params[name] = value;
            }
          }
        } else {
          params[name] = '';
        }
      }

      this.$emit('paramsFilter', params);

      return params;
    },

  },

};
